import React from 'react';

interface PreChatContainerProps {
    children: React.ReactNode;
    className?: string;
    containerClassName?: string;
}

export const PreChatContainer: React.FC<PreChatContainerProps> = ({
    children,
    className = '',
    containerClassName = ''
}) => {
    return (
        <div className={`w-full ${containerClassName}`}>
            <div className={`max-w-layout-container w-full flex flex-col items-center gap-6 mx-auto pt-6 pb-4 px-5 box-border ${className}`}>
                {children}
            </div>
        </div>
    );
};

export default PreChatContainer;
